import React, { useMemo } from 'react'
import { CardInfo } from '@shared'
import { useOverlayActions } from '@store'

interface GeneralPopupProps {
  image: string
  isAnimationImg?: boolean
  title: string
  description: string
  rewardType?: string
  children?: React.ReactNode
  onClose?: () => void
}

export const GeneralPopup = ({
  image,
  isAnimationImg = false,
  title,
  description,
  rewardType,
  onClose,
  children,
}: GeneralPopupProps) => {
  const { hideOverlay } = useOverlayActions()

  const handleClose = () => {
    hideOverlay()
    onClose?.()
  }

  const effects = useMemo(()=> {
    return {
      mask: rewardType === 'avatar' || rewardType === 'card' || rewardType === 'spiral_effect',
      holographic: isAnimationImg
    }
  },[rewardType, isAnimationImg]);

  return (
    <CardInfo 
      url={image} 
      effects={effects}
      onClose={handleClose}      
      title={title}
      description={description}
    >
      {children}
    </CardInfo>
  )
}
